{
  "schemaVersion": 1,
  "key": "desert",
  "name": "Desert",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/home.png"
  },
  "mascot": {
    "home": "mascot/tortoise.png"
  },
  "tokens": {
    "accent": "#8B4C9B"
  }
}
